var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAngleDownV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3968 6.2655C14.4252 6.2408 14.4394 6.22844 14.4506 6.21812C14.9928 5.72189 14.9928 4.86759 14.4506 4.37137C14.4394 4.36104 14.4252 4.34869 14.3968 4.32399C14.3793 4.30869 14.3705 4.30105 14.3623 4.29418C13.9826 3.9745 13.4499 3.90939 13.0043 4.12822C12.9947 4.13292 12.9844 4.13823 12.9637 4.14884L9.14189 6.10738C8.58207 6.39427 8.30216 6.53771 8.00009 6.53771C7.69801 6.53771 7.4181 6.39427 6.85828 6.10738L3.0365 4.14884C3.01579 4.13823 3.00543 4.13292 2.99586 4.12822C2.55032 3.90939 2.01756 3.9745 1.63783 4.29418C1.62967 4.30105 1.6209 4.30869 1.60335 4.32399C1.575 4.34869 1.56083 4.36104 1.54954 4.37137C1.00742 4.86759 1.00741 5.72188 1.54953 6.21812C1.56081 6.22844 1.57498 6.2408 1.60334 6.2655L6.3553 10.4064C7.13923 11.0896 7.5312 11.4311 8.00009 11.4311C8.46898 11.4311 8.86095 11.0896 9.64488 10.4064L14.3968 6.2655Z",
    fill: "#1B1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAngleDownV2);
export default __webpack_public_path__ + "static/media/icon-angle-down-v2.2434e2de0f6f68be97b8354b6fecd96e.svg";
export { ForwardRef as ReactComponent };